import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";
import { ArrowRight, HelpCircle } from "lucide-react";

const FAQS = [
    {
        q: "Vocês fabricam peças sob medida para máquinas agrícolas?",
        a: "Sim. Produzimos conforme desenho técnico ou necessidade específica.",
    },
    {
        q: "Atendem cooperativas e distribuidores?",
        a: "Sim. Trabalhamos com diferentes perfis do setor agrícola.",
    },
    {
        q: "Vocês realizam pintura industrial?",
        a: "Sim. Oferecemos acabamento para maior durabilidade.",
    },
    {
        q: "Qual o prazo médio de entrega?",
        a: "Depende da complexidade do projeto, mas priorizamos agilidade e previsibilidade.",
    },
];

export const Faq = () => {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="bg-buzas-gray section-pad"
        >
            <div className="container-buzas grid lg:grid-cols-[0.8fr,1.2fr] gap-12 lg:gap-16">
                <div>
                    <span className="eyebrow text-buzas-red">FAQ</span>
                    <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-buzas-navy leading-tight">
                        Dúvidas comuns.
                    </h2>
                    <p className="mt-5 text-base md:text-lg text-buzas-navy/70 leading-relaxed">
                        Respostas objetivas e técnicas para ajudar você a
                        planejar seu projeto.
                    </p>

                    <div className="mt-8 inline-flex items-center gap-3 rounded-sm border border-buzas-gray-200 bg-white p-4">
                        <div className="inline-flex h-10 w-10 items-center justify-center rounded-sm bg-buzas-navy text-white">
                            <HelpCircle className="h-5 w-5" />
                        </div>
                        <div>
                            <p className="text-sm font-bold text-buzas-navy">
                                Não encontrou sua dúvida?
                            </p>
                            <a
                                href="#contato"
                                data-testid="faq-cta-contato"
                                className="mt-0.5 inline-flex items-center gap-1 text-sm font-bold text-buzas-red hover:text-buzas-red-600"
                            >
                                Fale com um especialista
                                <ArrowRight className="h-3.5 w-3.5" />
                            </a>
                        </div>
                    </div>
                </div>

                <Accordion
                    type="single"
                    collapsible
                    className="w-full"
                    data-testid="faq-accordion"
                >
                    {FAQS.map((item, i) => (
                        <AccordionItem
                            key={item.q}
                            value={`item-${i}`}
                            data-testid={`faq-item-${i}`}
                            className="border-b border-buzas-gray-200"
                        >
                            <AccordionTrigger className="py-5 text-left text-base md:text-lg font-bold text-buzas-navy hover:no-underline">
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent className="pb-5 text-sm md:text-base text-buzas-navy/70 leading-relaxed">
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
};
